/**
 * DEMO-ONLY: Mock Data for Auto-Scheduling Demo
 *
 * Contains sample patients, care patterns, and configuration for demonstrating
 * the integrated auto-scheduling capabilities.
 */

// Mock patient data - 20 unique patients with "-AS" suffix
export interface MockPatient {
  firstName: string;
  lastName: string;
  mrn: string;
  dateOfBirth: string;
  phone: string;
  addressStreet: string;
  addressCity: string;
  addressState: string;
  addressZip: string;
}

export const MOCK_PATIENTS: MockPatient[] = [
  {
    firstName: 'John',
    lastName: 'Doe-AS',
    mrn: 'MRN00001',
    dateOfBirth: '1955-03-15',
    phone: '302-555-0101',
    addressStreet: '210 S College Ave',
    addressCity: 'Newark',
    addressState: 'DE',
    addressZip: '19711',
  },
  {
    firstName: 'Jane',
    lastName: 'Smith-AS',
    mrn: 'MRN00002',
    dateOfBirth: '1962-07-22',
    phone: '302-555-0102',
    addressStreet: '2 E Main St',
    addressCity: 'Newark',
    addressState: 'DE',
    addressZip: '19711',
  },
  {
    firstName: 'Robert',
    lastName: 'Johnson-AS',
    mrn: 'MRN00003',
    dateOfBirth: '1948-11-30',
    phone: '302-555-0103',
    addressStreet: '18 Amstel Ave',
    addressCity: 'Newark',
    addressState: 'DE',
    addressZip: '19711',
  },
  {
    firstName: 'Maria',
    lastName: 'Garcia-AS',
    mrn: 'MRN00004',
    dateOfBirth: '1970-01-18',
    phone: '302-555-0104',
    addressStreet: '66 E Main St',
    addressCity: 'Newark',
    addressState: 'DE',
    addressZip: '19711',
  },
  {
    firstName: 'William',
    lastName: 'Martinez-AS',
    mrn: 'MRN00005',
    dateOfBirth: '1959-09-05',
    phone: '302-555-0105',
    addressStreet: '22 S Chapel St',
    addressCity: 'Newark',
    addressState: 'DE',
    addressZip: '19711',
  },
  {
    firstName: 'Patricia',
    lastName: 'Rodriguez-AS',
    mrn: 'MRN00006',
    dateOfBirth: '1965-04-11',
    phone: '302-555-0106',
    addressStreet: '186 S College Ave',
    addressCity: 'Newark',
    addressState: 'DE',
    addressZip: '19711',
  },
  {
    firstName: 'James',
    lastName: 'Wilson-AS',
    mrn: 'MRN00007',
    dateOfBirth: '1952-12-25',
    phone: '302-555-0107',
    addressStreet: '300 Wyoming Rd',
    addressCity: 'Newark',
    addressState: 'DE',
    addressZip: '19711',
  },
  {
    firstName: 'Linda',
    lastName: 'Lopez-AS',
    mrn: 'MRN00008',
    dateOfBirth: '1968-06-08',
    phone: '302-555-0108',
    addressStreet: '181 S College Ave',
    addressCity: 'Newark',
    addressState: 'DE',
    addressZip: '19711',
  },
  {
    firstName: 'Michael',
    lastName: 'Gonzalez-AS',
    mrn: 'MRN00009',
    dateOfBirth: '1944-02-14',
    phone: '302-555-0109',
    addressStreet: '400 Elkton Rd',
    addressCity: 'Newark',
    addressState: 'DE',
    addressZip: '19711',
  },
  {
    firstName: 'Barbara',
    lastName: 'Hernandez-AS',
    mrn: 'MRN00010',
    dateOfBirth: '1973-10-03',
    phone: '302-555-0110',
    addressStreet: '125 Cleveland Ave',
    addressCity: 'Newark',
    addressState: 'DE',
    addressZip: '19711',
  },
  {
    firstName: 'David',
    lastName: 'Perez-AS',
    mrn: 'MRN00011',
    dateOfBirth: '1950-05-29',
    phone: '302-555-0111',
    addressStreet: '220 S College Ave',
    addressCity: 'Newark',
    addressState: 'DE',
    addressZip: '19711',
  },
  {
    firstName: 'Elizabeth',
    lastName: 'Sanchez-AS',
    mrn: 'MRN00012',
    dateOfBirth: '1966-08-17',
    phone: '302-555-0112',
    addressStreet: '52 E Main St',
    addressCity: 'Newark',
    addressState: 'DE',
    addressZip: '19711',
  },
  {
    firstName: 'Richard',
    lastName: 'Torres-AS',
    mrn: 'MRN00013',
    dateOfBirth: '1958-03-21',
    phone: '302-555-0113',
    addressStreet: '54 E Main St',
    addressCity: 'Newark',
    addressState: 'DE',
    addressZip: '19711',
  },
  {
    firstName: 'Jennifer',
    lastName: 'Ramirez-AS',
    mrn: 'MRN00014',
    dateOfBirth: '1971-11-12',
    phone: '302-555-0114',
    addressStreet: '124 E Main St',
    addressCity: 'Newark',
    addressState: 'DE',
    addressZip: '19711',
  },
  {
    firstName: 'Charles',
    lastName: 'Flores-AS',
    mrn: 'MRN00015',
    dateOfBirth: '1947-07-07',
    phone: '302-555-0115',
    addressStreet: '500 Capitol Trl',
    addressCity: 'Newark',
    addressState: 'DE',
    addressZip: '19711',
  },
  {
    firstName: 'Susan',
    lastName: 'Anderson-AS',
    mrn: 'MRN00016',
    dateOfBirth: '1956-09-13',
    phone: '302-555-0116',
    addressStreet: '450 Paper Mill Rd',
    addressCity: 'Newark',
    addressState: 'DE',
    addressZip: '19711',
  },
  {
    firstName: 'Anthony',
    lastName: 'Thomas-AS',
    mrn: 'MRN00017',
    dateOfBirth: '1964-05-27',
    phone: '302-555-0117',
    addressStreet: '156 E Main St',
    addressCity: 'Newark',
    addressState: 'DE',
    addressZip: '19711',
  },
  {
    firstName: 'Margaret',
    lastName: 'Taylor-AS',
    mrn: 'MRN00018',
    dateOfBirth: '1969-12-08',
    phone: '302-555-0118',
    addressStreet: '600 Casho Mill Rd',
    addressCity: 'Newark',
    addressState: 'DE',
    addressZip: '19711',
  },
  {
    firstName: 'Joshua',
    lastName: 'Moore-AS',
    mrn: 'MRN00019',
    dateOfBirth: '1953-08-02',
    phone: '302-555-0119',
    addressStreet: '750 Barksdale Rd',
    addressCity: 'Newark',
    addressState: 'DE',
    addressZip: '19711',
  },
  {
    firstName: 'Dorothy',
    lastName: 'Jackson-AS',
    mrn: 'MRN00020',
    dateOfBirth: '1967-02-20',
    phone: '302-555-0120',
    addressStreet: '190 S College Ave',
    addressCity: 'Newark',
    addressState: 'DE',
    addressZip: '19711',
  },
];

// Pre-configured care patterns
export const CARE_PATTERNS: Record<string, CarePattern> = {
  standard: {
    name: 'Standard 2x Daily',
    visitsPerDay: 2,
    duration: 60,
    timeWindows: [
      { earliestStart: '08:00', latestStart: '11:00' }, // Morning
      { earliestStart: '17:00', latestStart: '20:00' }, // Evening
    ],
  },
  singleDaily: {
    name: 'Reduced 1x Daily',
    visitsPerDay: 1,
    duration: 60,
    timeWindows: [
      { earliestStart: '08:00', latestStart: '14:00' }, // Wide morning window
    ],
  },
  reduced: {
    name: 'Reduced 2x Daily',
    visitsPerDay: 2,
    duration: 60,
    timeWindows: [
      { earliestStart: '08:00', latestStart: '11:00' }, // Morning
      { earliestStart: '17:00', latestStart: '20:00' }, // Evening
    ],
  },
  intensive: {
    name: 'Intensive 4x Daily',
    visitsPerDay: 4,
    duration: 45,
    timeWindows: [
      { earliestStart: '08:00', latestStart: '10:00' }, // Early morning
      { earliestStart: '11:00', latestStart: '13:00' }, // Midday
      { earliestStart: '15:00', latestStart: '17:00' }, // Afternoon
      { earliestStart: '19:00', latestStart: '21:00' }, // Evening
    ],
  },
};

// Default expected LOS for demo scenarios
export const DEFAULT_LOS_DAYS = 6;

// Demo-specific visit cancellation reason ID
// This will need to be resolved from org config or created
export const DEMO_CANCELLATION_REASON = 'Demo Reset';

/**
 * Helper to find routine visit type from org config
 */
export function findRoutineVisitType(visitTypes: Record<string, any>): number | null {
  const visitTypeArray = Object.values(visitTypes);

  // Try to find by name patterns
  const routine = visitTypeArray.find(
    (vt) =>
      vt.name?.toLowerCase().includes('routine') ||
      vt.name?.toLowerCase().includes('visit') ||
      vt.name?.toLowerCase().includes('standard')
  );

  if (routine) {
    return routine.id;
  }

  // Fallback to first available visit type
  return visitTypeArray[0]?.id || null;
}

/**
 * Helper to find discharge visit type from org config
 */
export function findDischargeVisitType(visitTypes: Record<string, any>): number | null {
  const visitTypeArray = Object.values(visitTypes);

  // Try to find by name patterns
  const discharge = visitTypeArray.find(
    (vt) =>
      vt.name?.toLowerCase().includes('discharge') ||
      vt.name?.toLowerCase().includes('final')
  );

  if (discharge) {
    return discharge.id;
  }

  // Fallback to routine visit type
  return findRoutineVisitType(visitTypes);
}

/**
 * Helper to find admission visit type from org config
 */
export function findAdmissionVisitType(visitTypes: Record<string, any>): number | null {
  const visitTypeArray = Object.values(visitTypes);

  // Try to find by name patterns
  const admission = visitTypeArray.find(
    (vt) =>
      vt.name?.toLowerCase().includes('admission') ||
      vt.name?.toLowerCase().includes('admit')
  );

  if (admission) {
    return admission.id;
  }

  // Fallback to routine visit type
  return findRoutineVisitType(visitTypes);
}

/**
 * Helper to get first available service line from org config
 */
export function getFirstServiceLine(serviceLines: Record<string, any>): number | null {
  const serviceLineArray = Object.values(serviceLines);
  return serviceLineArray[0]?.id || null;
}

/**
 * Helper to find demo cancellation reason from org config
 */
export function findDemoCancellationReason(
  visitCancellationReasons: Record<string, any>
): number | null {
  const reasonsArray = Object.values(visitCancellationReasons);

  // Try to find demo-specific reason
  const demoReason = reasonsArray.find((reason) =>
    reason.description?.toLowerCase().includes('demo')
  );

  if (demoReason) {
    return demoReason.id;
  }

  // Fallback to first available reason
  return reasonsArray[0]?.id || null;
}

export interface CarePattern {
  name: string;
  visitsPerDay: number;
  duration: number;
  timeWindows: Array<{
    earliestStart: string;
    latestStart: string;
  }>;
}
